import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-701df069.js';
import { I as Icon } from '../../Icon/Icon-258a20fc.js';
import { a as exclamation, i as infoCircle, e as exclamationTriangle, c as check, w as opportunities } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-1702ffd3-fa72660f.js';
import { f as faSpinner } from '../../LocalModules/storm-ui-icons/dist/esm/fortawesome-free-solid-svg-icons-4775a695-d7919d19.js';

const MessageIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30039089__sc-1jwbhbz-0"
})(["", " ", " ", ""], ({
  theme,
  $messagetype
}) => $messagetype === 'info' && css(["color:", ";"], theme.form.input.info.iconColor), ({
  theme,
  $messagetype
}) => $messagetype === 'warning' && css(["color:", ";"], theme.form.input.warning.iconColor), ({
  theme,
  $messagetype
}) => $messagetype === 'opportunity' && css(["color:", ";"], theme.palette.data.indigo[700]));
MessageIcon.displayName = 'MessageIcon';
const Message = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-30039089__sc-1jwbhbz-1"
})(["align-self:center;", ";font-size:", ";>{p,a,span,b,strong,i,em,ul,ol,abbr,cite{font-size:", ";}}line-height:1.25;display:flex;margin-top:", ";color:", ";svg{margin-inline-end:", ";}", " ", " ", " ", ""], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.typography.size.small, ({
  theme
}) => theme.typography.size.small, ({
  theme
}) => theme.spacing.micro, ({
  theme
}) => theme.form.input.message.color, ({
  theme
}) => theme.spacing.mini, isMobile(css(["", ";font-size:", ";>{p,a,span,b,strong,i,em,ul,ol,abbr,cite{font-size:", ";}}margin-top:", ";svg{margin-inline-end:", ";}"], ({
  theme
}) => theme.typography.mobile.base, ({
  theme
}) => theme.typography.mobile.size.small, ({
  theme
}) => theme.typography.mobile.size.small, ({
  theme
}) => theme.mobile.spacing.micro, ({
  theme
}) => theme.mobile.spacing.mini)), ({
  $messagetype,
  theme
}) => $messagetype === 'error' && `
    color:  ${theme.form.input.error.messageColor};
  `, ({
  $messagetype,
  theme
}) => $messagetype === 'warning' && `
    color:  ${theme.form.input.warning.messageColor};
  `, ({
  $messagetype,
  theme
}) => $messagetype === 'success' && `
    color:  ${theme.form.input.success.messageColor};
  `);
Message.displayName = 'Message';
const MessageIconMap = {
  error: exclamation,
  info: infoCircle,
  warning: exclamationTriangle,
  success: check,
  loading: faSpinner,
  opportunity: opportunities
};
class InlineMessage extends PureComponent {
  render() {
    const {
      messageType,
      message,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(Message, _extends({
      $messagetype: messageType
    }, rest), messageType && MessageIconMap[messageType] && /*#__PURE__*/React__default.createElement(MessageIcon, {
      type: MessageIconMap[messageType],
      $messagetype: messageType
    }), message);
  }
}
_defineProperty(InlineMessage, "propTypes", {
  /**
   * Specifies the type of message to be displayed.
   */
  messageType: PT.oneOf(['error', 'warning', 'success', 'loading', 'info', 'opportunity']),
  /**
   * Specifies the message to be displayed.
   */
  message: PT.oneOfType([PT.node, PT.string]).isRequired
});
_defineProperty(InlineMessage, "defaultProps", {
  messageType: undefined
});

export { InlineMessage as I };
//# sourceMappingURL=InlineMessage-a6ab0417.js.map
